<template>
  <section class="layout-section__toggle">
    <h6 class="layout__title">Creativity is nothing but the way to solve new problems.</h6>

    <ul class="tag">
      <li class="tag__item">Adobe XD</li>
      <li class="tag__item">Illustrator</li>
      <li class="tag__item">Photoshop</li>
      <li class="tag__item">Figma</li>
      <li class="tag__item">SCSS</li>
      <li class="tag__item">BEM</li>
      <li class="tag__item">Vue JS</li>
      <li class="tag__item">Git</li>
      <li class="tag__item">CLI</li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'HomeAbout'
}
</script>
